<template>
  <div class="with-load-more">
    <slot />
    <slot
      name="showMore"
      :visible="pagination.hasNextPage"
      :loading="isLoading"
      :onClick="onClick"
    >
      <div
        v-if="pagination.hasNextPage"
        class="with-load-more__button"
      >
        <WithSpinnerPlaceholder :loading="isLoading">
          <BasicButton
            appearance="secondary"
            size="m"
            @click="onClick"
          >Показать ещё</BasicButton>
        </WithSpinnerPlaceholder>
      </div>
    </slot>
  </div>
</template>

<script>
  import BasicButton from "src/components/BasicButton/BasicButton.vue";
  import WithSpinnerPlaceholder from "src/components/placeholders/WithSpinnerPlaceholder/WithSpinnerPlaceholder.vue";

  export default {
    name: 'WithLoadMore',
    components: { WithSpinnerPlaceholder, BasicButton },
    inject: ['pagination'],
    methods: {
      onClick() {
        this.pagination.appendNextPage();
      },
    },
    computed: {
      isLoading() {
        return this.pagination.loadingPage !== null && this.pagination.loadingPage !== 1;
      },
    },
  }
</script>